import React from 'react';
import { FetchBaseQueryError,  }from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

interface ErrorComponentProps {
    error?: FetchBaseQueryError | SerializedError;
};
 
export const ErrorComponent: React.FC<ErrorComponentProps> = (props) => {

   if(props.error) {
      console.log('error', props.error);
      const err = props.error;
      var e: any = 'unknown error';
      if('status' in err && err.status === 'PARSING_ERROR' && err.originalStatus === 500 && typeof(err.data) == "string" && err.data.startsWith('<!DOCTYPE html>')) {
        const height = '600px';
        e = <iframe srcDoc={err.data} title="error" style={{ height: height, maxHeight: height, maxWidth:"95%", overflow:"auto", display:"flex", width:"95%" }} className="border border-danger m-1 p-1"/>;
      } else {
        e = JSON.stringify(props.error);
        console.log(props.error);
      }
      return <div><h3 className='text-error'>Error</h3>{e}</div>;
   }
   return <span/>;
 }
 